import React, { useState, useEffect, useRef } from "react";
import { useMembers } from "../../context/membersContext.tsx";
import { useLocation } from "react-router-dom";
import Members from "./members/Members.tsx";
import NavBar from "../NavBar.jsx";
import DepartmentSection from "./members/Department.jsx";
import Recruitment from "./recruitment/Recruitment.jsx";
import teamBg from "../../images/team/team.jpg";
import Footer from "../Footer";
import gsap from 'gsap';

const deptConfig = [
  { id: "ES", label: "Electrical Systems"},
  { id: "HB", label: "Hull & Body"},
  { id: "MM", label: "Management & Marketing"},
  { id: "MS", label: "Mechanical Systems"},
];

function Departments() {
  const [department, setDepartment] = useState("");
  const [memberCount, setMemberCount] = useState(0);
  const { members } = useMembers();
  const headerRef = useRef(null);
  const heroRef = useRef(null);
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const hash = location.hash.replace('#', '');
      setTimeout(() => {
        const el = document.getElementById(hash);
        if (el) el.scrollIntoView({ behavior: 'smooth' });
      }, 300);
    }
  }, [location]);

  const totalMembers = members.filter(m => m.department !== "Alumni").length;
  const totalDepartments = deptConfig.length;

  useEffect(() => {
    if (heroRef.current) {
      gsap.fromTo('.hero-content',
        { y: 40, opacity: 0 },
        { y: 0, opacity: 1, duration: 0.8, ease: 'power3.out' }
      );
    }
    if (headerRef.current) {
      gsap.fromTo(headerRef.current,
        { y: 40, opacity: 0 },
        { y: 0, opacity: 1, duration: 0.7, ease: 'power3.out' }
      );
    }
  }, []);

  return (
    <div className="relative">
      <NavBar />

      <div
        ref={heroRef}
        className="relative h-[100vh] h-[100dvh] flex items-center justify-center bg-cover"
        style={{ backgroundImage: `url(${teamBg})`, backgroundPosition: '30% 50%' }}
      >
        <div className="absolute inset-0 bg-gradient-to-b from-slate-900/30 via-slate-900/40 to-slate-950" />
        <div className="relative z-10 text-center px-4 hero-content">
          <h1 className="font-custom font-bold text-5xl sm:text-6xl md:text-7xl lg:text-8xl text-white leading-tight mb-4">
            Meet our team
          </h1>
          <div className="inline-flex items-center gap-6 bg-white/2 backdrop-blur-md border border-white/10 rounded-2xl px-5 py-3">
            <div className="text-center">
              <p className="text-3xl md:text-4xl font-bold text-white font-custom">{totalDepartments}</p>
              <p className="text-gray-400 text-[10px] sm:text-xs uppercase tracking-wider mt-1 font-custom">Departments</p>
            </div>
            <div className="w-px h-10 md:h-12 bg-white/15" />
            <div className="text-center">
              <p className="text-3xl md:text-4xl font-bold text-white font-custom">{totalMembers || '...'}</p>
              <p className="text-gray-400 text-[10px] sm:text-xs uppercase tracking-wider mt-1 font-custom">Members</p>
            </div>
          </div>
        </div>
      </div>

       <div id="departments"><DepartmentSection /></div>

       <div id="members" className="w-full bg-gradient-to-b from-slate-950 via-slate-900 to-slate-950 py-20 px-4">
         <div className="max-w-6xl mx-auto">
           <div ref={headerRef} className="text-center mb-4 md:mb-6">
             <h2 className="font-custom text-4xl md:text-6xl lg:text-7xl font-bold text-white">Members</h2>
          </div>

          <div className="flex flex-wrap justify-center gap-2 mb-6">
            <button
              onClick={() => setDepartment("")}
              className={`px-5 py-2.5 md:px-6  rounded-full text-sm md:text-base font-medium font-custom transition-all duration-300 ${
                department === ""
                  ? 'bg-white text-slate-900 shadow-lg shadow-white/10 scale-105'
                  : 'bg-white/5 text-gray-400 border border-white/10 hover:bg-white/10 hover:text-white'
              }`}
            >
              All
            </button>
            {deptConfig.map((dept) => (
              <button
                key={dept.id}
                onClick={() => setDepartment(department === dept.id ? "" : dept.id)}
                className={`px-5 py-2.5 md:px-6 md:py-3 rounded-full text-sm md:text-base font-medium font-custom transition-all duration-300 ${
                  department === dept.id
                    ? 'bg-mainBlue text-white shadow-lg shadow-mainBlue/20 scale-105'
                    : 'bg-white/5 text-gray-400 border border-white/10 hover:bg-white/10 hover:text-white'
                }`}
              >
                {dept.label}
              </button>
            ))}
            <button
              onClick={() => setDepartment(department === "Alumni" ? "" : "Alumni")}
              className={`px-5 py-2.5 md:px-6 md:py-3 rounded-full text-sm md:text-base font-medium font-custom transition-all duration-300 ${
                department === "Alumni"
                  ? 'bg-amber-500 text-white shadow-lg shadow-amber-500/20 scale-105'
                  : 'bg-amber-500/10 text-amber-300/60 border border-amber-500/20 hover:bg-amber-500/20 hover:text-amber-300'
              }`}
            >
              Alumni
            </button>
          </div>

          <Members department={department} onCountChange={setMemberCount} />
        </div>
      </div>

      <div id="recruitment">
        <Recruitment />
      </div>
      <Footer />
    </div>
  );
}

export default Departments;
